import Swal from 'sweetalert2';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import * as _ from 'lodash';

import { RossConfigService } from 'src/@ross/services/config.service';
import { RossSidebarService } from 'src/@ross/components/sidebar/sidebar.service';

import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { GestionPmService } from 'src/app/pages/gestion-pm/gestion-pm.service';
import { RossNavigationService } from 'src/@ross/components/navigation/navigation.service';
import { ToolBarNotificationsService } from 'src/app/shared/services/notifications.service';
import { ProfileImageService } from 'src/app/shared/services/profile-image-service.service';

@Component({
  selector     : 'toolbar',
  templateUrl  : './toolbar.component.html',
  styleUrls    : ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {

  rightNavbar: boolean;
  hiddenNavbar: boolean;
  private _unsubscribeAll: Subject<any>;
  profileImageUrl: string | ArrayBuffer | null = null;

  currentUser: any = {};
  idDetailUser: any;
  cookie = localStorage.getItem('CiDi') || 'cidi';
  aptitud: any;

  actions: any;
  notificaciones: {
    noRead: number,
    list: []
  } = {
    noRead: 0,
      list: []
  }

  constructor(
    private _rossConfigService: RossConfigService,
    private _rossSidebarService: RossSidebarService,
    private _rossNavigationService: RossNavigationService,
    private router: Router,
    private _authService: AuthenticationService,
    private _gestionService: GestionPmService,
    private _toolBarNotificationsService: ToolBarNotificationsService,
    private profileImageService: ProfileImageService

  ) {
    // this.navigation = navigation;
    this._unsubscribeAll = new Subject();
    this.currentUser = this._authService.currentUserValue;

  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {

    // this.profileImageService.profileImageUrl$.subscribe(url => {
    //   this.profileImageUrl = url as string | ArrayBuffer;
    // });

    this.profileImageService.profileImageUrl$.subscribe((url) => {
      this.profileImageUrl = url as string | ArrayBuffer;
    });
    
    // Subscribe to the config changes
    this._rossConfigService.config
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((settings) => {
        this.rightNavbar = settings.layout.navbar.position === 'right';
        this.hiddenNavbar = settings.layout.navbar.hidden === true;
    });

    this._toolBarNotificationsService.getNotificationsCampana().subscribe((res: any) => {
      this.notificaciones.noRead = res.response.notificationsNoReadCount;
      this.notificaciones.list = res.response.notifications;
    })


  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  toggleSidebarOpen(key): void {
      this._rossSidebarService.getSidebar(key).toggleOpen();
  }

  logout() {

    this._authService.logout(this.cookie);
    localStorage.clear();
    this.router.navigate(['/login']).then(data => {
      this._rossNavigationService.unregister('main');
      location.reload();
    });

  }

  goProfile() {

    this._gestionService.getUser(this.currentUser.user_id).subscribe(
      resp=>{

        Swal.fire({
          title: 'Info Perfil',
          icon: 'info',
          html: `
          <b>Nombre:</b> ${resp.response[0] && resp.response[0].NAME || ''} ${resp.response[0] && resp.response[0].SURNAME || 'user'} <br>
          <b>Perfil:</b> ${resp.response[0] && resp.response[0].PROFILE || 'Perfil no encontrado'} <br>

          <b>Cuit:</b> ${resp.response[0] && resp.response[0].CUIT || '--'}
                `,
          showConfirmButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          })
      },error=>{
        Swal.fire({
          title: 'Info Perfil',
          icon: 'error',
          text: 'Hubo un error al procesar la información del Perfil',
          showConfirmButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          })
      }

    )
   // this.router.navigate(['/pages/gestion-pm/edit-pm', this.currentUser.user_id, this.idDetailUser ]);
  }

  getUserActions() {
    this._gestionService.getUser(this.currentUser.user_id).subscribe(
      resp => {
        this.actions = resp.actions;
      }, error => {
        console.error('Error al obtener las acciones del usuario', error);
      }
    );
  }

  goNotifications(){
    this.router.navigate(['/pages/notificacion/notificacion/recibido']);

    // this.notificaciones.noRead = 0;
  }
}
